import { render, staticRenderFns } from "./AnswerOverview.vue?vue&type=template&id=6c4102a0&scoped=true&"
import script from "./AnswerOverview.vue?vue&type=script&lang=js&"
export * from "./AnswerOverview.vue?vue&type=script&lang=js&"
import style0 from "./AnswerOverview.vue?vue&type=style&index=0&id=6c4102a0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4102a0",
  null
  
)

export default component.exports